/*eslint-disable*/ export const messages = JSON.parse("{\"checkbox-group.label.optional\":[\"Valgfri\"],\"checkbox-group.validation.required\":[\"Mindst én valgt mulighed er påkrævet.\"]}");
//# sourceMappingURL=messages.mjs.map